import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mb, mh, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {priceFormat} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {OfferType} from "../../offer/types/OfferType";

const receivingKeysImg = require("../images/receiving_keys.jpg");

interface IProps {
    offerType: OfferType;
    regionSlug: string;
    minPriceM2: string;
}

export const ArchitectOfferPromoBox = (props: IProps) => {
    const target = useResponsiveLinkTarget();
    const minPriceM2 = parseFloat(props.minPriceM2);

    return (
        <div css={[architectPromoBoxWrapper]}>
            <div css={[imageColumnStyle]}>
                <Image src={receivingKeysImg} width="266px" height="260px" alt="Architekci - oferta" />
            </div>
            <div css={[contentColumnStyle]}>
                <Text variant="headline_2" css={[textCenterOnMobile, mb(3)]}>
                    Wykończ {props.offerType === OfferType.HOUSE ? "ten dom" : "to mieszkanie"}
                </Text>
                <Text as="div" variant="headline_6" css={[textCenterOnMobile, mb(2)]}>
                    Zobacz atrakcyjne pakiety wykończenia pod klucz z gwarancją ceny i terminu!
                </Text>
                {Number.isFinite(minPriceM2) && (
                    <Text as="div" variant="headline_5" css={[textCenterOnMobile, mb(3)]}>
                        <Highlight>
                            od{" "}
                            <Text as="span" variant="headline_2">
                                {priceFormat(minPriceM2)}
                            </Text>
                            /m2
                        </Highlight>
                    </Text>
                )}
                <Button href={rpAppLink.architect.city({regionSlug: props.regionSlug})} target={target} variant="filled_primary" css={buttonStyle}>
                    Sprawdź
                </Button>
            </div>
        </div>
    );
};

const architectPromoBoxWrapper = (theme: Theme) => css`
    ${p(2)};
    ${backgroundColor("#fff")};
    ${borderRadius(2)};
    position: relative;
    ${flex()};
    ${flexDirection("column")};
    ${mh("auto")};
    max-width: 336px;

    @media (min-width: ${theme.breakpoints.xs}) {
        max-width: 348px;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()};
        ${flexDirection("row")};
        column-gap: ${calculateRemSize(2)};
        max-width: unset;
    }
`;

const imageColumnStyle = (theme: Theme) => css`
    ${mb(2)};
    ${flexAbsoluteCenter};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${mb(0)};
    }

    img {
        width: 266px;
        height: 260px;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        img {
            width: 210px;
            height: 204px;
        }
    }
`;

const contentColumnStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        flex: 1 1 100%;
    }
`;

const buttonStyle = (theme: Theme) => css`
    width: 100%;

    @media (min-width: ${theme.breakpoints.sm}) {
        width: auto;
        min-width: 20rem;
    }
`;

const textCenterOnMobile = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mb, mh, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {priceFormat} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {OfferType} from "../../offer/types/OfferType";

const receivingKeysImg = require("../images/receiving_keys.jpg");

interface IProps {
    offerType: OfferType;
    regionSlug: string;
    minPriceM2: string;
}

export const ArchitectOfferPromoBox = (props: IProps) => {
    const target = useResponsiveLinkTarget();
    const minPriceM2 = parseFloat(props.minPriceM2);

    return (
        <div css={[architectPromoBoxWrapper]}>
            <div css={[imageColumnStyle]}>
                <Image src={receivingKeysImg} width="266px" height="260px" alt="Architekci - oferta" />
            </div>
            <div css={[contentColumnStyle]}>
                <Text variant="headline_2" css={[textCenterOnMobile, mb(3)]}>
                    Wykończ {props.offerType === OfferType.HOUSE ? "ten dom" : "to mieszkanie"}
                </Text>
                <Text as="div" variant="headline_6" css={[textCenterOnMobile, mb(2)]}>
                    Zobacz atrakcyjne pakiety wykończenia pod klucz z gwarancją ceny i terminu!
                </Text>
                {Number.isFinite(minPriceM2) && (
                    <Text as="div" variant="headline_5" css={[textCenterOnMobile, mb(3)]}>
                        <Highlight>
                            od{" "}
                            <Text as="span" variant="headline_2">
                                {priceFormat(minPriceM2)}
                            </Text>
                            /m2
                        </Highlight>
                    </Text>
                )}
                <Button href={rpAppLink.architect.city({regionSlug: props.regionSlug})} target={target} variant="filled_primary" css={buttonStyle}>
                    Sprawdź
                </Button>
            </div>
        </div>
    );
};

const architectPromoBoxWrapper = (theme: Theme) => css`
    ${p(2)};
    ${backgroundColor("#fff")};
    ${borderRadius(2)};
    position: relative;
    ${flex()};
    ${flexDirection("column")};
    ${mh("auto")};
    max-width: 336px;

    @media (min-width: ${theme.breakpoints.xs}) {
        max-width: 348px;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()};
        ${flexDirection("row")};
        column-gap: ${calculateRemSize(2)};
        max-width: unset;
    }
`;

const imageColumnStyle = (theme: Theme) => css`
    ${mb(2)};
    ${flexAbsoluteCenter};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${mb(0)};
    }

    img {
        width: 266px;
        height: 260px;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        img {
            width: 210px;
            height: 204px;
        }
    }
`;

const contentColumnStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        flex: 1 1 100%;
    }
`;

const buttonStyle = (theme: Theme) => css`
    width: 100%;

    @media (min-width: ${theme.breakpoints.sm}) {
        width: auto;
        min-width: 20rem;
    }
`;

const textCenterOnMobile = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;
